export enum ContentStatus {
	CURRENT = 'CURRENT',
	DRAFT = 'DRAFT',
	ARCHIVED = 'ARCHIVED',
}
